import { useState } from 'react';
import { StateId } from '@acp/shared';
import { RegionUtil } from '../utils/region-util';

function useLogin({
    stateId,
    stateParameter,
    onLogin,
}: {
    stateId: StateId;
    stateParameter: string | null;
    onLogin: (url: string) => void;
}) {
    const [isLoggingIn, setIsLoggingIn] = useState(false);

    const login = () => {
        const redirectUrl = RegionUtil.getRedirectLoginUrl(
            stateId,
            encodeURI(stateParameter ?? '/'),
            ''
        );

        setIsLoggingIn(true);
        onLogin(redirectUrl);
    };

    return { isLoggingIn, login };
}

export { useLogin };
